module.exports = __webpack_public_path__ + "media/images/bw-logo-4fc0972587d0977b5d94ccaa0f462f7b.png";